<template>
    <span :class="{ 'trigger-with-menu': true, open: open }">
        <span @click.stop="toggle" ref="trigger">
            <slot />
        </span>
        <div class="trigger-with-menu-menu" v-if="open" v-click-outside="dismiss" @click="dismiss">
            <slot name="menu" />
        </div>
    </span>
</template>
<script setup>
import { ref } from 'vue'

const trigger = ref(null)
const open = ref(false)

function toggle() {
    open.value = !open.value
}

function dismiss(event) {
    if (!trigger.value?.contains(event.target)) {
        open.value = false
    }
}
</script>
<style scoped>
.trigger-with-menu {
    position: relative;

    /* nuke tooltips */
    :deep(&.open[data-tooltip] [data-tooltip-text]) {
        display: none;
    }

    .trigger-with-menu-menu {
        background-color: white;

        box-shadow: var(--boxshadow-menu);
        font-size: var(--font-size-normal-text);
        line-height: 32px;
        min-width: 272px;
        padding: 8px 16px;
        position: absolute;
        right: 8px;
        top: 48px;
        white-space: nowrap;
        z-index: var(--z-index-dropdown-menu);
    }
}
</style>
